import React from 'react';

import { ModalDialog } from 'src/web/components/Modals/ModalDialog';
import { ErrorMessage } from '../../styles';

interface RemoveFromInstitutionModalProps {
  totalMembersRemove: number;
  isLoading: boolean;
  error: string;
  onActionCallback: () => void;
  onHide: () => void;
}

export const RemoveFromInstitutionModal: React.FC<RemoveFromInstitutionModalProps> = ({
  totalMembersRemove,
  isLoading,
  error,
  onActionCallback,
  onHide,
}) => {
  return (
    <>
      <ModalDialog
        show
        center
        small
        onHide={onHide}
        title="Remove from institution"
        actions={[
          {
            label: 'Cancel',
            onClick: onHide,
            type: 'default',
          },
          {
            label: 'Yes, remove',
            showSpinner: isLoading,
            disabled: isLoading,
            onClick: () => onActionCallback(),
            type: 'danger',
          },
        ]}
      >
        You are about to remove {totalMembersRemove} team member
        {totalMembersRemove > 1 ? 's' : ''} from the institution. Are you sure
        you want to proceed?
        <br />
        <ErrorMessage>{error}</ErrorMessage>
      </ModalDialog>
    </>
  );
};
